import { render, staticRenderFns } from "./ActionTypeNameColumn.vue?vue&type=template&id=460972e4&"
import script from "./ActionTypeNameColumn.vue?vue&type=script&lang=js&"
export * from "./ActionTypeNameColumn.vue?vue&type=script&lang=js&"
import style0 from "./ActionTypeNameColumn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JIT002729\\solas\\fc\\JIT\\frontDev_2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('460972e4')) {
      api.createRecord('460972e4', component.options)
    } else {
      api.reload('460972e4', component.options)
    }
    module.hot.accept("./ActionTypeNameColumn.vue?vue&type=template&id=460972e4&", function () {
      api.rerender('460972e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/table/ActionTypeNameColumn.vue"
export default component.exports